import { formatChartTooltipHeader } from '../production-groups/chartTooltipHeader';

// Matches the compact week.two-digit-year format used by the dashboard's shared chart defaults.
export const activeGroupsWeekAxisLabels = { format: '{value:%W.%y}', rotation: 0 };

export const formatActiveGroupsChartTooltipHeader = formatChartTooltipHeader;
